<!--Copy right - © 2024 tecera gmbh-->
<script>
    import { Link } from "svelte-routing";
</script>

<svelte:head>
    <title>myBach | 404</title>
</svelte:head>

<div class="background-container">
    <div class="form-signin">
    <img
        src="img/250105_Logo_Bach_myBach_Logo_White_small.svg"
        alt="Login_logo"
    />
        <p class="login-headline">Diese Seite existiert nicht</p>
        <div
            style="display:flex;flex-direction:column;justify-content:space-between;align-items:center;"
        >
            <div class="login-row">
                <Link
                    class="btn btn-link "
                    to="/"
                    style=" font-size: 1rem; font-weight: 550;white-space: wrap;"
                >
                    Zurück zum Login
                </Link>
            </div>
        </div>
    </div>
</div>
